import { RecordsPageHeader } from '@pages/Clients/Records/components/RecordsPageHeader';

import { Records } from '@pages/Clients/Records/Records.main';

export { RecordsPageHeader, Records };
